import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function weightScalesReducer(state = initialState.apiConfig, action) {
    switch (action.type) {        
        case types.LOAD_API_CONFIG_SUCCESS:
            return {...action};
        default:
            return state;
    }
}